// iOS/iPadOS WebKit browsers
// Check support status at: https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html
export const iOSMediaQuery = '@supports (-webkit-touch-callout: none)';
